const APIURL = {
  USER_REGISTER: '/media-member/h5/adminUser/register', // 用户注册
  TG_LOGIN: '/media-auth/tg/oauth/token', // tg 地址登陆
  USER_LOGIN: '/media-auth/app/oauth/token', // 用户登陆
  USER_SEDRET: '/media-auth/app/secret/oauth/token', // 加密登陆
  ISCHECK_CAPTCHE: '/media-member/h5/adminUser/isCheckCaptcha', //获取是否开启防水码
  BIND_PHONE: '/media-member/h5/adminUser/build/mobile', //绑定手机号
  GET_PHONE_CODE: '/media-member/h5/adminUser/verificationCode', //获取手机验证码
  RESET_PASSWORD: '/media-member/h5/adminUser/update/password', //修改密码
  USER_INFO: '/media-member/h5/adminUser/info', //用户信息
  USER_LOGOUT: '/media-auth/app/oauth/logout', //账号登出
  WATCHHISTORY: `/media-site/h5/watchHistory/watchHistory/list`, //获取浏览记录
  collectionList: `/media-site/h5/favorite/collection/list` //获取收藏记录
}

// 账号登出
export const userLogOutApi = (params = {}) => {
  return httpRequest.post(APIURL.USER_LOGOUT, params)
}
// 广告列表
export const getAdListApi = (params = {}) => {
  return httpRequest.post(APIURL.AD_LIST, params, { server: false })
}
// 用户注册
export const userRegisterApi = (params = {}, headers = {}) => {
  return httpRequest.post(APIURL.USER_REGISTER, params, { headers })
}
// 获取是否开启防水码
export const getIsCheckCaptchaApi = (params = {}) => {
  return httpRequest.post(APIURL.ISCHECK_CAPTCHE, params)
}
// 用户登陆
export const userLogInApi = (params = {}, isEncrypt = 0) => {
  return httpRequest.post(isEncrypt == 1 ? APIURL.USER_SEDRET : APIURL.USER_LOGIN, params)
}
// 绑定手机号
export const bindPhoneApi = (params = {}) => {
  return httpRequest.post(APIURL.BIND_PHONE, params)
}
// 获取手机验证码
export const getPhoneCodeApi = (params = {}) => {
  return httpRequest.post(APIURL.GET_PHONE_CODE, params)
}
// 获取手机验证码
export const resetPasswordApi = (params = {}) => {
  return httpRequest.post(APIURL.RESET_PASSWORD, params)
}
// 用户信息
export const getUserInfoApi = (params = {}) => {
  return httpRequest.post(APIURL.USER_INFO, params)
}

// 获取浏览记录
export const watchHistoryList = (params = {}) => {
  return httpRequest.post(APIURL.WATCHHISTORY, params, { server: false })
}
// 获取收藏记录 media-site/h5/favorite/collection/list
export const collectionList = (params = {}) => {
  return httpRequest.post(APIURL.collectionList, params, { server: false })
}
